function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols-Algemeen",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings/Venue-Selector/Dashboard",
  transform: "translate(-29.000000, -58.000000)",
  stroke: "#43BDCF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,61.1170464 L32.2468318,64.1538462 C33.5956266,62.0333775 34.8466827,60.5333775 36,59.6538462",
  id: "Path-2-Copy-2"
})));
function SvgVenueVink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenueVink);
export default __webpack_public_path__ + "static/media/venue_vink.9bea4e021b1082ae056175ea96376801.svg";
export { ForwardRef as ReactComponent };